import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/invoiceService";
import { getApiErrorMessage } from "../../utils/apiError";

export const fetchInvoices = createAsyncThunk("invoices/fetchAll", async (params) => {
  const res = await svc.getInvoices(params);
  return res.data;
});

export const createInvoiceThunk = createAsyncThunk("invoices/create", async (data, { rejectWithValue }) => {
  try {
    const res = await svc.createInvoice(data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to save invoice."));
  }
});

export const updateInvoiceThunk = createAsyncThunk("invoices/update", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await svc.updateInvoice(id, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to update invoice."));
  }
});

export const deleteInvoiceThunk = createAsyncThunk("invoices/delete", async (id, { rejectWithValue }) => {
  try {
    await svc.deleteInvoice(id);
    return id;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to delete invoice."));
  }
});

const invoiceSlice = createSlice({
  name: "invoices",
  initialState: { list: [], loading: false, error: null, selected: null },
  reducers: {
    setSelectedInvoice: (state, action) => { state.selected = action.payload; },
    clearSelectedInvoice: (state) => { state.selected = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoices.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchInvoices.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchInvoices.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createInvoiceThunk.fulfilled, (state, action) => { state.list.unshift(action.payload); })
      .addCase(updateInvoiceThunk.fulfilled, (state, action) => {
        if (!action.payload) return;
        const idx = state.list.findIndex((i) => i.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteInvoiceThunk.fulfilled, (state, action) => {
        state.list = state.list.filter((i) => i.id !== action.payload);
      });
  },
});

export const { setSelectedInvoice, clearSelectedInvoice } = invoiceSlice.actions;
export default invoiceSlice.reducer;
